var _ellipse, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarEarned({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.1349,
    cy: 20,
    rx: 19.9387,
    ry: 20,
    fill: "#70E1E1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.8665 17.8074C27.6791 17.231 27.1673 16.8585 26.5629 16.8585H22.6648L21.4373 13.1193C21.2486 12.5445 20.7379 12.174 20.1352 12.174C20.1348 12.174 18.3064 18.3904 18.3064 18.3904L20.1348 24.6069L23.2987 26.9246C23.7882 27.2831 24.4214 27.2842 24.9121 26.9275C25.4028 26.5708 25.5989 25.9668 25.4116 25.3887L24.2021 21.6546H24.2184L27.3716 19.3449C27.8597 18.9873 28.054 18.3838 27.8665 17.8074Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1286 12.174C19.5234 12.1764 19.0129 12.5515 18.8282 13.1296L17.6364 16.8585H13.7059C13.0999 16.8585 12.5878 17.2322 12.4012 17.8106C12.2146 18.3889 12.4114 18.9927 12.9026 19.3488L16.0697 21.645L14.857 25.3886C14.6697 25.9668 14.8658 26.5708 15.3565 26.9275C15.8472 27.2842 16.4805 27.283 16.9699 26.9245L20.134 24.6068C20.134 24.6069 20.134 12.174 20.134 12.174C20.1322 12.174 20.1304 12.174 20.1286 12.174Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarEarned);
export default __webpack_public_path__ + "static/media/star-earned.820a46eea12c4bf8457ff1809e1b777f.svg";
export { ForwardRef as ReactComponent };